import { ChangeDetectionStrategy, Component } from '@angular/core';
import { crossFade } from 'src/animations/crossfade.animation';
import { progressFade } from '../../animations/progressfade.animation';
import { ArticleKind } from '../../models/article.model';
import { BookFacade } from '../../state/book/book.facade';
import { CdFacade } from '../../state/cd/cd.facade';
import { ChronicleFacade } from '../../state/chronicle/chronicle.facade';
import { CoinFacade } from '../../state/coin/coin.facade';
import { DvdFacade } from '../../state/dvd/dvd.facade';
import { FolderFacade } from '../../state/folder/folder.facade';
import { NewspaperFacade } from '../../state/newspaper/newspaper.facade';
import { PageFacade } from '../../state/page/page.facade';
import { RouterFacade } from '../../state/router/router.facade';
import { StickFacade } from '../../state/stick/stick.facade';
import { YearBookFacade } from '../../state/year-book/year-book.facade';
import { PageComponent } from '../page.component';

@Component({
	selector: 'shop-page-gift',
	templateUrl: './page-gift.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [crossFade, progressFade],
})
export class PageGiftComponent extends PageComponent {
	public ArticleKinds = ArticleKind;

	constructor(
		public newspaperFacade: NewspaperFacade,
		public pageFacade: PageFacade,
		public routerFacade: RouterFacade,
		public bookFacade: BookFacade,
		public yearBookFacade: YearBookFacade,
		public cdFacade: CdFacade,
		public dvdFacade: DvdFacade,
		public coinFacade: CoinFacade,
		public chronicleFacade: ChronicleFacade,
		public folderFacade: FolderFacade,
		public stickFacade: StickFacade
	) {
		super();
	}
}
